import React from 'react';
import './css/WelcomeCardsSection.css';
import defaultImg from '../../../assets/images/logo/13.png';

export default function WelcomeCardsSection({ data }) {
  const titulo = data?.titulo || 'UMA IGREJA PARA VOCÊ';
  const subtitulo = data?.subtitulo || 'Domingos às 19h | Sede ADCN - Caldas Novas, GO';
  const cards = data?.cards || [];

  console.log('[WelcomeCardsSection] Dados recebidos:', data);
  console.log('[WelcomeCardsSection] Cards:', cards);

  return (
    <section className="welcome-cards-section">
      <div className="welcome-header">
        <h2>{titulo}</h2>
        <p>{subtitulo}</p>
      </div>

      {cards.length > 0 && (
        <div className="cards-container">
          {cards.map((card, index) => {
            const imageUrl = card.imagem || defaultImg;
            console.log(`[WelcomeCardsSection] Card ${index} - imagem:`, imageUrl);
            
            return (
              <div key={index} className="card">
                <div 
                  className="card-image" 
                  style={{ 
                    backgroundImage: `url("${imageUrl}")`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center'
                  }}
                >
                  <h3>{card.titulo || ''}</h3>
                </div>
                <div className="card-text">
                  <h4>{card.subtitulo || ''}</h4>
                  <p>{card.texto || ''}</p>
                  {card.link && (
                    <a href={card.link}>SAIBA MAIS</a>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}
